<template>
  <div>
    <span
        v-for="error in getMessageError('value_cash')"
        v-if="getMessageError('value_cash')"
        class="help-block has-error">
      <strong>{{ error }}</strong>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      errors: []
    }
  },
  methods: {
    hasError(key) {
      return this.errors.find(error => error.field === key);
    },
    getMessageError(key) {
      let error = this.hasError(key);

      if (error) {
        let keyError = this.errors.indexOf(error);
        return this.errors[keyError].message;
      }

      return null;
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/inputs/HandleErrors.vue